import formatNmber from './formatNumber';

export default (value) => `${formatNmber(value && (Math.round(value * 1000) / 10) )}%`;
